import { Text } from "@chakra-ui/layout";
import React from "react";

export default function MyParagraph({ children }) {
  return <Text>{children}</Text>;
}
